var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _HznCurrencyInput_instances, _HznCurrencyInput_emit, _HznCurrencyInput_cleaveRef, _HznCurrencyInput_cleaveFirstUpdate, _HznCurrencyInput_noDecimals, _HznCurrencyInput_handleStripDecimals, _HznCurrencyInput_handlePadDecimals, _HznCurrencyInput_handleCleaveValueChanged;
// class definition
import { property } from '@horizon/base/decorators';
import { eventEmitter } from '@horizon/common/events';
import { currencyRequiredValidator, currencyPatternValidator, currencyMinValidator, currencyMaxValidator } from './currency-validators.js';
import { minLengthValidator, maxLengthValidator, typeMismatchValidator, customValidator } from '@horizon/common/mixins';
import Cleave from '@horizon/base/cleave';
import { HznInput, handleClear } from '@horizon/input';
export const CURRENCY_PATTERN = '^[-]?[$]\\d{1,3}(?:,?\\d{3})*(.\\d{2})?$';
const ZERO_WIDTH_SPACE = '\u200B';
/**
 *
 * @tag hzn-currency-input
 * @tagname hzn-currency-input
 * @summary
 */
export class HznCurrencyInput extends HznInput {
    static get formControlValidators() {
        return [
            currencyRequiredValidator,
            typeMismatchValidator,
            currencyMinValidator,
            currencyMaxValidator,
            minLengthValidator,
            maxLengthValidator,
            currencyPatternValidator,
            customValidator
        ];
    }
    /**
     * Set whether or not decimals are allowed to be typed. When changed dynamically to true, existing decimals in the input's value will be removed
     */
    get noDecimals() {
        return __classPrivateFieldGet(this, _HznCurrencyInput_noDecimals, "f");
    }
    set noDecimals(newValue) {
        const oldValue = this.noDecimals;
        __classPrivateFieldSet(this, _HznCurrencyInput_noDecimals, newValue, "f");
        if (__classPrivateFieldGet(this, _HznCurrencyInput_cleaveRef, "f")) {
            if (__classPrivateFieldGet(this, _HznCurrencyInput_noDecimals, "f")) {
                __classPrivateFieldGet(this, _HznCurrencyInput_cleaveRef, "f").properties.numeralDecimalMark = ZERO_WIDTH_SPACE;
                // @ts-ignore
                __classPrivateFieldGet(this, _HznCurrencyInput_cleaveRef, "f").properties.numeralFormatter.numeralDecimalMark = ZERO_WIDTH_SPACE;
                // remove decimals if they are currently present in the input
                __classPrivateFieldGet(this, _HznCurrencyInput_handleStripDecimals, "f").call(this);
            }
            else {
                __classPrivateFieldGet(this, _HznCurrencyInput_cleaveRef, "f").properties.numeralDecimalMark = '.';
                // @ts-ignore
                __classPrivateFieldGet(this, _HznCurrencyInput_cleaveRef, "f").properties.numeralFormatter.numeralDecimalMark = '.';
            }
        }
        this.requestUpdate('noDecimals', oldValue);
    }
    /**
     * @private
     */
    [(_HznCurrencyInput_emit = new WeakMap(), _HznCurrencyInput_cleaveRef = new WeakMap(), _HznCurrencyInput_cleaveFirstUpdate = new WeakMap(), _HznCurrencyInput_noDecimals = new WeakMap(), _HznCurrencyInput_handleStripDecimals = new WeakMap(), _HznCurrencyInput_handlePadDecimals = new WeakMap(), _HznCurrencyInput_instances = new WeakSet(), handleClear)]() {
        this.value = '$';
        this.focus();
        __classPrivateFieldGet(this, _HznCurrencyInput_emit, "f").call(this, { type: 'clear' });
    }
    constructor() {
        super();
        _HznCurrencyInput_instances.add(this);
        /**
         * @private
         */
        _HznCurrencyInput_emit.set(this, eventEmitter(this));
        _HznCurrencyInput_cleaveRef.set(this, void 0);
        _HznCurrencyInput_cleaveFirstUpdate.set(this, true);
        _HznCurrencyInput_noDecimals.set(this, false);
        /**
         * @private
         * Set the default initial value to '$' so that currency input validation only happens if the value is different from '$'
         */
        this.defaultInitialValue = '$';
        this.rawValue = '';
        /**
         * Set whether or not to automatically pad decimals on blur
         */
        this.padDecimals = false;
        _HznCurrencyInput_handleStripDecimals.set(this, () => {
            const value = this.value;
            const hasDecimal = value.indexOf('.') > 0;
            if (hasDecimal) {
                const [left] = value.split('.');
                // adding 00 to the right side, then substringing to 2 digits handles
                // the use case where the user only types 1 decimal place: ie, $1234.5 => $1234.50
                // but if 2 decimal places exist, they are left alone
                this.value = left;
                this.rawValue = left.substring(1);
            }
        });
        _HznCurrencyInput_handlePadDecimals.set(this, () => {
            const value = this.value;
            // dont pad if the value isn't different from the defaultInitialValue
            if (value === this.defaultInitialValue) {
                return;
            }
            const hasDecimal = value.indexOf('.') > 0;
            if (hasDecimal) {
                const [left, right] = value.split('.');
                // adding 00 to the right side, then substringing to 2 digits handles
                // the use case where the user only types 1 decimal place: ie, $1234.5 => $1234.50
                // but if 2 decimal places exist, they are left alone
                this.value = `${left}.${`${right}00`.substring(0, 2)}`;
                this.rawValue = `${left.substring(1)}.${`${right}00`.substring(0, 2)}`;
            }
            else {
                this.value = value + '.00';
                this.rawValue = value.substring(1) + '.00';
            }
        });
        // hardcoded currency input defaults
        this.type = 'text';
        this.sensitive = false;
        this.pattern = CURRENCY_PATTERN;
    }
    firstUpdated() {
        __classPrivateFieldSet(this, _HznCurrencyInput_cleaveRef, new Cleave(this.validationTarget, {
            numeral: true,
            numeralPositiveOnly: true,
            rawValueTrimPrefix: true,
            delimiter: ',',
            // use zero width space here to trick cleave into not applying decimals
            numeralDecimalMark: __classPrivateFieldGet(this, _HznCurrencyInput_noDecimals, "f") ? ZERO_WIDTH_SPACE : '.',
            prefix: '$',
            onValueChanged: (e) => {
                if (!__classPrivateFieldGet(this, _HznCurrencyInput_cleaveFirstUpdate, "f")) {
                    __classPrivateFieldGet(this, _HznCurrencyInput_instances, "m", _HznCurrencyInput_handleCleaveValueChanged).call(this, e);
                }
                else {
                    // this handles a race condition between cleave setting the '$' prefix
                    // which runs an `onValueChanged` potentially before the firstUpdated function is finished
                    // if we are running the very first one, we check to see if there's a value, and if not set our value with '$'
                    // just in case the cleaveRef hasnt finishing creating. If there is a value, everything renders fine because of the order of the
                    // lit re-rendering
                    if (!this.value) {
                        this.value = '$';
                    }
                }
                __classPrivateFieldSet(this, _HznCurrencyInput_cleaveFirstUpdate, false, "f");
            },
        }), "f");
        // set initial value if present
        if (this.value) {
            __classPrivateFieldGet(this, _HznCurrencyInput_cleaveRef, "f").setRawValue(this.value);
        }
        // do this check first because this is the first time values are all set with DOM access
        // after this check the setters in padDecimals will take over in removing the listeners when needed
        // validationTarget is also defined by this point as well
        if (this.padDecimals && !this.noDecimals) {
            this.validationTarget.addEventListener('blur', __classPrivateFieldGet(this, _HznCurrencyInput_handlePadDecimals, "f"));
        }
    }
    willUpdate() {
        // hardcoded overrides of hzn-input options
        // these will always be set right before any update
        this.type = 'text';
        this.sensitive = false;
        this.pattern = CURRENCY_PATTERN;
    }
}
_HznCurrencyInput_handleCleaveValueChanged = function _HznCurrencyInput_handleCleaveValueChanged(e) {
    // console.log(this.#cleaveRef);
    // check for this.#cleaveRef because the prefix insertion counts as a value change,
    // so the intial prefix set happens almost before this.#cleaveRef has been defined
    if (__classPrivateFieldGet(this, _HznCurrencyInput_cleaveRef, "f")) {
        this.rawValue = __classPrivateFieldGet(this, _HznCurrencyInput_cleaveRef, "f").getRawValue();
        this.value = e.target.value;
    }
};
__decorate([
    property({ type: Boolean, attribute: 'no-decimals' })
], HznCurrencyInput.prototype, "noDecimals", null);
__decorate([
    property({ type: Boolean, attribute: 'pad-decimals' })
], HznCurrencyInput.prototype, "padDecimals", void 0);
//# sourceMappingURL=currency-input.js.map